/**
 * @file DealHeaderActions.tsx
 * @description Видимые кнопки шапки карточки сделки (phase19.31; замечание
 * владельца 2026-10-02 «достань все кнопки из трёх точек»): «Сменить
 * стадию», «Заказ Z-…», «Доска сделок», «Обновить» — стандартные
 * кнопки-контуры, без меню «⋯».
 *
 * Название сделки важнее кнопок (приёмка QA-5 D3/D4): кнопки разложены на две
 * части (`part`) для `CabinetPageHeader`:
 *  - `panel` — «Сменить стадию» и «Заказ Z-…» (`panelActions`): в панели
 *    только от 1280 (вместе с главным «Создать заказ» — не больше трёх),
 *    уже — строкой под шапкой;
 *  - `row` — «Доска сделок» и «Обновить» (`secondaryActions` +
 *    `secondaryBelow`): всегда строкой под шапкой.
 * Опасных действий у сделки в шапке нет.
 *
 * «Сменить стадию» — единственный способ перенести сделку на телефоне
 * (доска там без перетаскивания); при закрытии сделки окно спросит причину.
 */

import { ArrowRightLeft, Kanban, Package, RefreshCw } from "lucide-react";
import { Link } from "react-router";

import { Button } from "../../ui/button";
import type { OrderDto } from "../../../lib/api-orders";

interface Props {
  part: "panel" | "row";
  /** Связанный заказ; нет — кнопки «Заказ» нет. */
  order: Pick<OrderDto, "id" | "number"> | null;
  orderHref: string | null;
  boardHref: string;
  onRefresh: () => void;
  refreshing: boolean;
  /** «Сменить стадию»; нет — кнопки нет (нет права или стадия закрыта). */
  onChangeStage?: () => void;
}

export function DealHeaderActions({ part, order, orderHref, boardHref, onRefresh, refreshing, onChangeStage }: Props) {
  if (part === "panel") {
    return (
      <>
        {onChangeStage ? (
          <Button variant="outline" onClick={onChangeStage}>
            <ArrowRightLeft className="size-4" aria-hidden />
            Сменить стадию
          </Button>
        ) : null}
        {order && orderHref ? (
          <Button variant="outline" asChild>
            <Link to={orderHref}>
              <Package className="size-4" aria-hidden />
              <span className="tabular-nums">Заказ {order.number}</span>
            </Link>
          </Button>
        ) : null}
      </>
    );
  }
  return (
    <>
      <Button variant="outline" asChild>
        <Link to={boardHref}>
          <Kanban className="size-4" aria-hidden />
          Доска сделок
        </Link>
      </Button>
      <Button variant="outline" onClick={onRefresh} loading={refreshing}>
        <RefreshCw className="size-4" aria-hidden />
        Обновить
      </Button>
    </>
  );
}
